import { getShipName } from '../../utils/utils';
import { Link } from 'react-router-dom';
import { OwnedTargetInfo, SnapshotData } from 'ais-facade-api/api';
import { useAddToFleetMutation } from 'app/api/fleet';
import { useAppSelector } from 'app/store/store';
import { Icon, VesselIcon } from 'app/components';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Button } from '../Button';

import styles from './AISCard.module.scss';
import { motionlessSpeed } from 'app/constants/_constants';
import { useAlertHook } from 'hooks/useAlertHook';
interface AISCardHeaderI {
  onClose: () => void;
  shipInfo?: OwnedTargetInfo | SnapshotData;
  shipRequestRefetch: () => void;
}

export const AISCardHeader = ({ onClose, shipInfo, shipRequestRefetch }: AISCardHeaderI) => {
  const { t } = useTranslation();
  const { addAlert } = useAlertHook();

  if (!shipInfo) {
    return null;
  }

  const rotateDeg = () => {
    const speed = 'sog' in shipInfo ? shipInfo.sog : 'position' in shipInfo ? shipInfo.position?.sog : null;
    if (typeof speed === 'number' && speed < motionlessSpeed) return 0;

    if ('registryData' in shipInfo && shipInfo.registryData?.specialType === 'ATON') return 0;
    if ('position' in shipInfo) return shipInfo.position?.heading || shipInfo.position?.cog || 0;
    if ('heading' in shipInfo) return shipInfo.heading;
    if ('cog' in shipInfo) return shipInfo.cog;
    else return 0;
  };

  const IconStyle = {
    transform: 'rotate(' + rotateDeg() + 'deg)',
  };

  const user = useAppSelector((state) => state.userSlice.user);
  const [addToFleet] = useAddToFleetMutation();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [shipInfo]);

  function handleAddToFleet() {
    const user_id = user?.value.sub;

    if (user_id && typeof shipInfo?.mmsi === 'number') {
      setIsLoading(true);
      addToFleet({ mmsiArray: [shipInfo.mmsi] })
        .unwrap()
        .then(() => {
          setIsLoading(false);
          shipRequestRefetch();
        })
        .catch((error) => {
          setIsLoading(false);
          addAlert({
            data: {
              title: error.data.title,
              status: 403,
              detail: error.data.detail,
              messages: [{ description: error.data.messages[0].description, type: error.data.messages[0].type }],
            },
          });
        })
    }
  }

  return (
    <div className={styles.header_wrapper}>
      <div className={styles.header}>
        <div className={styles.ship_type_icon} style={IconStyle}>
          <VesselIcon vessel={shipInfo} />
        </div>
        <div className={styles.name}>{getShipName(shipInfo)}</div>
        <div onClick={onClose}>
          <Icon name="close-16" size="16px" />
        </div>
      </div>

      <div className={styles.sub_header}>
        <div className={styles.type}>
          {'meta' in shipInfo && (shipInfo.meta?.type ? shipInfo.meta.type : <div className={styles.no_data}>&mdash;</div>)}
        </div>

        {'belongsToFleet' in shipInfo &&
          (shipInfo.belongsToFleet ? (
            <Link className={styles.fleet} to="/fleet">
              <Icon name="my-fleet" width="13px" height="12px" />
              {t('FleetLabel')}
            </Link>
          ) : (
            <Button onClick={handleAddToFleet} disabled={isLoading} variant="ghost">
              <Icon name="add" size="14px" />
              {t('FleetLabel')}
            </Button>
          ))}
      </div>
    </div>
  );
};
